import { useEffect, useRef } from "react";
import { useIsComponentMounted } from "../../hooks/useIsComponentMounted";
import NitroService from "../../utils/nitro.service";
import NitroFilter from "../NitroFilter";
import { LocationIcon } from "../../icons";
import { useIsMobile } from "../../hooks/useIsMobile";

const LocationFilter = ({
  value,
  setValue,
  disabled,
  size,
  customPaper,
  autoFocus,
}: {
  value: string;
  setValue: (value: string) => void;
  disabled?: boolean;
  size?: "small" | "medium";
  customPaper?: boolean;
  autoFocus?: boolean;
}) => {
  const isMobile = useIsMobile(768);

  const getRecords = async (v: string) => {
    const records = await NitroService.getLocationNames(v);
    return [
      { label: "", value: "" },
      ...records.map((r) => {
        return { label: r.name || "", value: r.name || "" };
      }),
    ];
  };

  const ref = useRef<HTMLInputElement | null>(null);
  const isComponentMounted = useIsComponentMounted();
  useEffect(() => {
    if (!isComponentMounted) return;
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [isComponentMounted, autoFocus]);

  return (
    <NitroFilter
      placeholder="Facility Name"
      data={{ getRecords }}
      value={value}
      setValue={setValue}
      disabled={disabled}
      size={size}
      isMobile={isMobile}
      type="autocomplete"
      config={{ customPaper }}
      Icon={<LocationIcon color="#383838" />}
    />
  );
};

export default LocationFilter;
